var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonitoring(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 -960 960 960",
    fill: "#2968C9",
    width: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130.001-130.001v-65.768l59.998-59.998v125.766h-59.998Zm160 0v-225.768l59.998-59.998v285.766h-59.998Zm160 0v-285.766l59.998 60.998v224.768h-59.998Zm160 0v-224.768l59.998-59.998v284.766h-59.998Zm160 0v-385.768l59.998-59.998v445.766h-59.998Zm-640-221.232v-84.536L400-705.768l160 160 269.999-269.999v84.536L560-461.232l-160-160-269.999 269.999Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitoring);
export default __webpack_public_path__ + "static/media/monitoring.657de0fddc8c1e0f1239c6a410a103b7.svg";
export { ForwardRef as ReactComponent };